import React from 'react';
import {
  Alert,
  Box,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Typography,
} from '@benchlabs/react-design-system';
import { ChangeEvent, FC, useState } from 'react';
import { LedgerAccount } from './types';

interface LedgerSelectBpaUploadProps {
  ledgerAccounts: LedgerAccount[];
  onLedgerAccountSelect: (ledgerId: string) => void;
}

export const LedgerSelectBpaUpload: FC<LedgerSelectBpaUploadProps> = ({
  ledgerAccounts,
  onLedgerAccountSelect,
}: LedgerSelectBpaUploadProps) => {
  const [selectedLedgerId, setSelectedLedgerId] = useState<string>('');

  const handleLedgerAccountChange = (event: ChangeEvent<HTMLInputElement>) => {
    const ledgerId = (event.target as HTMLInputElement).value;
    setSelectedLedgerId(ledgerId);
    onLedgerAccountSelect(ledgerId);
  };

  return (
    <Box>
      <Alert severity="warning" sx={{ marginBottom: 2 }}>
        <Typography component="p" fontWeight="bold">
          Warning: Multi-account statements not accepted in this option. Please ensure all
          statements uploaded are towards the same ledger.
        </Typography>
      </Alert>
      <Typography gutterBottom variant="h2">
        Available Ledgers
      </Typography>
      {ledgerAccounts.length > 0 ? (
        <FormControl>
          <FormLabel id="select-ledger-radio-group-label">
            Please select the ledger you would like to upload to:
          </FormLabel>
          <RadioGroup
            aria-labelledby="select-ledger-radio-group-label"
            name="select-ledger-radio-group"
            onChange={handleLedgerAccountChange}
            value={selectedLedgerId}
            aria-label="Ledger Accounts"
          >
            {ledgerAccounts.map(({ name, id }) => (
              <FormControlLabel key={id} value={id} control={<Radio />} label={name} />
            ))}
          </RadioGroup>
        </FormControl>
      ) : (
        <Typography component="p">No ledgers found.</Typography>
      )}
    </Box>
  );
};
